import { InjectionToken } from '@angular/core';

export interface UserServiceInterface {
  hasCapability: (capabilityNameToCheck: string) => boolean;
}
export const USER_SERVICE = new InjectionToken<UserServiceInterface>('USER_SERVICE');
